import { ajaxSend } from 'api/api';
const v1Path = '/v1/users/agents';
export function getAgents({ params = {}, path = v1Path, }) {
    return ajaxSend({
        path,
        params,
    });
}
